export default class FAQ {
    constructor(element) {
        this.element = element;
        this.abortController = null;
        this.linkSelector = [
            '.faq-categories a',
            '.pages-pagination a.page-item',
            '.faq-question-card',
            '.faq-back-link',
            '.faq-sidebar-links a',
            '.single-faq-related-card'
        ].join(', ');

        this.handleClick = this.handleClick.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
        this.handleNavigateEvent = this.handleNavigateEvent.bind(this);
        this.init();
    }

    init() {
        document.body.addEventListener('click', this.handleClick);
        window.addEventListener('popstate', this.handlePopState);
        this.element.addEventListener('faq:navigate', this.handleNavigateEvent);

        history.replaceState({ faqUrl: window.location.href }, '', window.location.href);
    }

    handleClick(event) {
        const link = event.target.closest(this.linkSelector);
        if (!link || link.classList.contains('disabled')) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.target === '_blank' || link.hasAttribute('download')) return;

        const targetUrl = link.href;
        if (!targetUrl || new URL(targetUrl, window.location.href).origin !== window.location.origin) return;

        event.preventDefault();
        this.navigate(targetUrl, { push: true, focus: true });
    }

    handleNavigateEvent(event) {
        if (event.detail?.url) {
            this.navigate(event.detail.url, { push: true, focus: true });
        }
    }

    handlePopState() {
        this.navigate(window.location.href, { push: false, focus: false });
    }

    async navigate(targetUrl, { push, focus }) {
        this.abortController?.abort();
        const controller = new AbortController();
        this.abortController = controller;
        this.element.classList.add('is-loading');
        this.element.setAttribute('aria-busy', 'true');

        try {
            const response = await fetch(targetUrl, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                signal: controller.signal
            });

            if (!response.ok) {
                throw new Error(`FAQ request failed with status ${response.status}`);
            }

            const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fragment = responseDocument.querySelector('[data-faq-ajax-content]');

            if (!fragment) {
                throw new Error('FAQ response did not contain an AJAX fragment');
            }

            this.element.innerHTML = fragment.innerHTML;
            document.querySelector('.faq-page')?.classList.toggle('single-faq-page', fragment.dataset.faqView === 'single');

            if (fragment.dataset.pageTitle) {
                document.title = fragment.dataset.pageTitle;
            }

            if (push) {
                history.pushState({ faqUrl: targetUrl }, '', targetUrl);
            }

            if (focus) {
                this.element.querySelector('[data-faq-focus], h2')?.focus({ preventScroll: true });
                this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                window.location.href = targetUrl;
            }
        } finally {
            if (this.abortController === controller) {
                this.element.classList.remove('is-loading');
                this.element.removeAttribute('aria-busy');
            }
        }
    }
}

